<template>
  <form action="" class="trip-form" @submit.prevent="submit">
    <div class="trip-form__item">
      <div class="d-input" :class="{ _error: v$.form.name.$errors.length }">
        <input type="text" name="name" placeholder="Ваше имя*" class="d-input__field" v-model="v$.form.name.$model" :disabled="loading" @blur="v$.form.name.$touch"  @input="filterInputName">
        <div class="d-input__error" v-for="(error, index) of v$.form.name.$errors" :key="index">{{ error.$message }}</div>
      </div>
    </div>
    <div class="trip-form__item">
      <div class="d-input" :class="{ _error: v$.form.phone.$errors.length }">
        <div class="d-input__error" v-for="(error, index) of v$.form.phone.$errors" :key="index">{{ error.$message }}</div>
        <d-phone-input @change-phone="setPhone" @change-mask="updatePhoneParams" :reset="reset" @blur="blurInpPhone"/>
      </div>
    </div>
    <div class="trip-form__item _project">
      <d-select v-model="v$.form.project.$model" :data-options="projects" data-placeholder="Выберите объект*" mod="contacts"/>
    </div>
    <div class="trip-form__item _agree">
      <div class="d-callMe__agree d-checkbox _agree">
        <input type="checkbox" name="agree_trip" id="agree_trip" class="d-checkbox__input" @change="v$.form.agree.$touch()" v-model="v$.form.agree.$model">
        <label for="agree_trip" class="d-checkbox__label _inline">Согласен с </label><a :href="politicsLink" target="_blank">политикой обработки персональных данных</a>
      </div>
      <d-recaptcha-info :errored="errored" :error-text="errorText" />
    </div>
    <div class="trip-form__item _submit">
      <button class="d-callMe__button d-button _blue" :class="{_disable: v$.form.$invalid}" @click.prevent="submit"><span>Отправить</span></button>
    </div>
  </form>
</template>

<script>
import DPhoneInput from "@components/molecules/DPhoneInput.vue";
import DSelect from "@components/molecules/DSelect.vue";
import Inputmask from "inputmask";
import {helpers, required, sameAs} from "@vuelidate/validators";
import phoneHelper from "@utils/phoneHelper";
import {toRaw} from "vue";
import useVuelidate from "@vuelidate/core";
import DRecaptchaInfo from "@components/atoms/DRecaptchaInfo.vue";

export default {
  name: "DTripForm",
  components: {
    DRecaptchaInfo,
    DSelect,
    DPhoneInput
  },
  props: {
    actionUrl: {
      type: String,
      default: '',
    },
    projects: {
      type: Array,
      default: () => []
    },
    politicsLink: {
      type: String,
      default: '',
    },
    type: {
      type: [String, Array],
      default: 'trip',
    }
  },
  setup() {
    return {v$: useVuelidate()};
  },
  data() {
    return {
      form: {
        name: '',
        phone: '',
        project: '',
        agree: false,
      },
      errored: false,
      errorText: 'Ошибка при инициализации reCAPTCHA, попробуйте перезагрузить страницу',
      loading: false,
      phoneParams: {
        mask: '',
        code: ''
      },
      reset: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      Inputmask('+9 (999) 999-99-99', {jitMasking: true, placeholder: ''}).mask($(this.$refs.tel));
    });
  },
  methods: {
    submit() {
      this.v$.$touch();
      if (!this.v$.$invalid) {
        console.log('submit')
        this.sendData({...this.form, formType: 'trip'});
      }
    },
    async sendData(formdata) {
      console.log('formdata', formdata)
      formdata.URL = formdata.url = window.location.href;
      this.loading = true;
      try {
        await this.$recaptchaLoaded();
        formdata.token = await this.$recaptcha(this.type);
        const response = await this.axios.post(this.actionUrl, formdata);

        if (response.data.error) {
          this.errored = true;
          this.errorText = response.data.error;
        }
        else if (response.data.success) {
          this.resetForm();
          this.$emit('success');
          window.layoutAapp.$vfm.show({component: 'DPopupSuccess', bind: Object.assign({}, response.data, {content: response.data.success})});
        }
        else {
          console.error(response.data);
          this.errored = true;
        }
      } catch (error) {
        console.error(error);
        this.errored = true;
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.v$.form.$reset();
      this.form.name = '';
      this.form.phone = '+7 ';
      this.form.project = '';
      this.form.agree = false;
      this.reset = true;
      setTimeout(() => {this.reset = false;}, 1000);
    },
    filterInputName(event) {
      const onlyLetters = event.target.value.replace(/[^a-zA-Zа-яА-ЯёЁ ]/g, '');
      this.v$.form.name.$model = onlyLetters;
      event.target.value = onlyLetters;
    },
    updatePhoneParams(data) {
      this.phoneParams.mask = data.mask;
      this.phoneParams.code = data.code;
    },
    setPhone(phone) {
      this.form.phone = phone;
      console.log('setPhone phone = ', phone);
    },
    blurInpPhone() {
      this.v$.form.phone.$touch()
      console.log('touch phone')
    }
  },
  validations() {
    return {
      form: {
        name: {
          required: helpers.withMessage('Заполните это поле', required),
        },
        project: { required },
        phone: {
          required: helpers.withMessage('Заполните это поле', required),
          phoneHelper: helpers.withMessage('Введите номер полностью', phoneHelper(this.phoneParams)),
        },
        agree: {
          required,
          sameAs: sameAs(true),
        },
      },
    };
  },
}
</script>



<style scoped>

</style>